import { createFileRoute } from '@tanstack/react-router'
import { CustomerAttributes } from '@/components/settings-route/customer/attribute'

export const Route = createFileRoute('/_auth/settings/customers/attributes')({
  component: CustomAttributesWrapper,
})

export default function CustomAttributesWrapper() {
  return <CustomerAttributes />
}
